

(function () {
    angular.module('tmx-app')
        .factory('ToastService', ['$mdToast',function ($mdToast) {
            var toast = this;
            var toastPosition = {
                bottom: false,
                top: true,
                left: false,
                right: true
            };

            var getToastPosition = function () {
                return Object.keys(toastPosition)
                    .filter(function (pos) {
                        return toastPosition[pos];
                    })
                    .join(' ');
            };

            var showCustomToast = function (type, message) {
                if(!message) {
                    return;
                }
                var delay=5000;
                if(type=="success"){
                    delay=6000;
                }

                var toast = $mdToast.simple()
                    .content(message)
                    .theme(type)
                    .action('OK')
                    .highlightAction(false)
                    .position(getToastPosition())
                    .hideDelay(delay);//10000
                $mdToast.show(toast).then(function () {
                    // if (response == 'ok') {
                    $mdToast.hide();
                    // }
                });
            };

            var showSimpleToast = function (type, message) {
                var toast = $mdToast.simple()
                    .content(message)
                    .theme(type)
                    .highlightAction(false)
                    .position(getToastPosition())
                    .hideDelay(5000);
                $mdToast.show(toast).then(function () {
                    $mdToast.hide();
                });
            };

            var showActionToast = function (type, message) {
                var toast = $mdToast.simple()
                    .textContent(message)
                    .theme(type)
                    .action('OK')
                    .highlightAction(false)
                    .position(getToastPosition())
                    .hideDelay(false);
                $mdToast.show(toast).then(function (response) {
                    if (response == 'ok') {
                        $mdToast.hide();
                    }
                });
            };

            toast.showCustomToast = showCustomToast;
            toast.showActionToast = showActionToast;
            toast.showSimpleToast = showSimpleToast;

            return toast;
        }]);//end of service

})();//end of file